// import memoized from 'nano-memoize';

export default function currency(val) {
  if (val == null) {
    return '-';
  }
  if (val === '') {
    return '-';
  }
  if (typeof val === 'string') {
    return val;
  }
  // if (val < 0) {
  //   return '-';
  // }
  return val.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// export default memoized(currency, {
//   maxArgs: 1,
// });
